/*
 * @Author: your name
 * @Date: 2021-01-06 12:13:32
 * @LastEditTime: 2021-01-06 12:14:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/lib/ui/components/form/form-ocr-input/index.js
 */
import FormOrcInput from './form-ocr-input.vue'

FormOrcInput.install = (vue) => {
  vue.component(FormOrcInput.name, FormOrcInput)
}

export default FormOrcInput